import { Component, Host, Prop, h } from "@stencil/core";

/**
 * @slot (title) - for the title element of the teaser-icon
 * @slot (text) - for the text element of the teaser-icon
 * @slot (link) - for the link element of the teaser-icon
 */

@Component({
    tag: "ux-iws-teaser-icon",
    styleUrl: "teaser-icon.scss",
})
export class ServiceTeaser {
    private baseClass = "ux-iws-teaser-icon";

    /** the name of the icon of the teaser */
    @Prop() iconName: string = null;
    /** set icon size */
    @Prop() iconSize?: string = null;
    /** set icon weight */
    @Prop() iconWeight?: string = null;
    /** teaser with box shadow */
    @Prop() shadow: boolean = false;
    /** the variant of the icon teaser */
    @Prop() variant: string = "";

    render() {
        return (
            <Host
                class={{
                    [this.baseClass]: true,
                    ["ux-u-shadow"]: this.shadow,
                    [`${this.baseClass}--shadow`]: this.shadow,
                    [`${this.baseClass}--${this.variant}`]:
                        !!this.variant.length,
                }}
            >
                <ux-iws-link-wrapper class={`${this.baseClass}__container`}>
                    <slot name="image" />
                    <div class={`${this.baseClass}__wrapper`}>
                        {this.iconName !== null && (
                            <div class={`${this.baseClass}__icon-container`}>
                                <ux-icon
                                    name={this.iconName}
                                    size-l={this.iconSize}
                                    weight={this.iconWeight}
                                ></ux-icon>
                            </div>
                        )}
                        <slot name="title"></slot>
                        <slot name="text"></slot>
                        <slot name="link"></slot>
                    </div>
                </ux-iws-link-wrapper>
            </Host>
        );
    }
}
